export default __webpack_public_path__ + "static/gt-29d3df94129493282c5933d4fef4fc13.svg";